<script>
import { dataLayerEvent } from '@utils/data-layer.js';

export default {
    name: "Question",
    methods: {
        buttonClickEvent() {
            dataLayerEvent({
                eventId: 9,
                event: 'vntGeo',
                eventCategory: 'glavnaya',
                eventLabel: 'ostavit_zayavku',
                eventAction: 'element_click',
                buttonLocation: 'question'
            });
        }
    }
}
</script>

<template>
    <div id="question" class="question">
        <div class="block-wrap">
            <div class="block-content">
                <h3>Остались вопросы?</h3>
                <div class="block-content-body">
                    <p class="content-text">Расскажем, покажем и поможем выбрать наиболее подходящий для вас сервис</p>
                    <div class="question-btn">
                        <div
                            class="ui-button primary granat filled medium d-inline-block"
                            data-product="GeoEffect"
                            data-vitrine="Геоэффект"
                            data-btn-view="hidden"
                            data-bo-hw-lead-button="true"
                            data-bo-required-inn="true"
                            data-bo-not-required="email"
                            data-bo-subline=""
                            data-btn-text="Оставить заявку"
                            @click="buttonClickEvent"
                        >
                            <p>
                                Оставить заявку
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="question-img-container">
                <div class="question-img" />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import '@design/sections/question.scss';
    @import '@components/ui/ui-button/design/style.scss';
</style>